export class Form {
  constructor(data) {
    this.originalData = data;
    //crate all key and values to access this.name make key = value of all data
    for (let field in data) {
      this[field] = data[field];
    }
    this.errors = new Errors();
  }
  reset() {
    for (let field in this.originalData) {
      // this.originalData[field] = '' // it is not reactive
      this[field] = ""; // this is ractive after make for field in data
    }
  }

  // data which we are sending
  data() {
    // clone object clear all unnessery data and for sending request
    let data = Object.assign({}, this);
    delete data.originalData;
    delete data.errors;
    return data;
  }
}

class Errors {
  constructor() {
    this.errors = {};
  }

  has(field) {
    return this.errors.hasOwnProperty(field);
  }

  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0];
    }
  }

  record(errors) {
    this.errors = errors;
  }

  clear(val) {
    // this.errors[val] = ''
    // i think we can rid of this field cause if we ara typing it is clear automatcly
    // we call this on type input and claering errors field
    // if(val){
    delete this.errors[val];
    // return;
    // }
    // this.errors = {}
  }
  clearall() {
    this.errors = {};
  }
  any() {
    // how this any is reactive
    // return true or false for disavled validations
    return Object.keys(this.errors).length > 0;
  }
}
